import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const addEndpoint = ApiEndpoints.dynamicPage.Create;

const userName = !localStorage.getItem("username") ? "Admin" : localStorage.getItem("username");

export default function AddDynamicPage() {
  const navigate = useNavigate();

  const [previews, setPreviews] = useState({ banner_image: null, first_section_image: null, second_section_image: null, third_section_image: null});

  const [postData, setPostData] = useState({ title: "", slug: "", banner_description:"", banner_image: null, alt_banner_image: "", first_section_title: "", first_section_description: "", first_section_image: null, first_section_image_alt: "", second_section_title: "", second_section_description: "", second_section_image: null, second_section_image_alt: "", third_section_title: "", third_section_description: "", third_section_image: null, third_section_image_alt: "", third_section_subtitle: "", third_section_url: "", third_section_button_name: "", first_section_url: "", first_section_button_name: "", faqs: [{ question: "", answer: "" }, { question: "", answer: "" },] });


  const handleChange = (e) => {
    const { name, value, files } = e.target;
  
    if (files) {
      const file = files[0];  
      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));
  
      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file, 
      }));
    } else {
      // For non-file inputs, update the postData state directly
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

 
  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };


  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if (key !== "brief" && (value === "" || value === null)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      if(key === "faqs") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });

    try {
      const response = await ApiRequest("POST", addEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.message);
      navigate("/dynamic-page");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };


  // =========FAQS Functionality==========

  // 🔹 handle change for question/answer
  const handleFaqChange = (index, field, value) => {
    setPostData((prev) => {
      const updatedFaqs = [...prev.faqs];
      updatedFaqs[index][field] = value;
      return { ...prev, faqs: updatedFaqs };
    });
  };

  // 🔹 add new FAQ
  const addFaq = () => {
    setPostData((prev) => ({
      ...prev,
      faqs: [...prev.faqs, { question: "", answer: "" }],
    }));
  };

  // 🔹 remove FAQ
  const removeFaq = (index) => {
    setPostData((prev) => ({
      ...prev,
      faqs: prev.faqs.filter((_, i) => i !== index),
    }));
  };

  // =======FAQs Functionality End==========


    const pagename = {
      name: 'Dynamic Page',
      user: 'Admin',
      innerpage: 'Dynamic Page / Add Page'
    }

  return (
    <>
      <AdminHeader pagename={pagename}/>
      
      <div className="add-content-page">
        <form id="blogAdd" onSubmit={handleSubmit}>

          <div className="add-content-wrap">
            <h4>Banner Section</h4>
            <div className="row">
              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Banner Image Alt Text<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="alt_banner_image" type="text" className="form-control" placeholder="Enter Banner Image Alt Text" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.banner_description} onChange={(event, editor) => handleEditorChange("banner_description", editor.getData())}/>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Banner Image (1920 × 1034)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="banner_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]} 
                    onImageChange={handleChange}
                    imagePreview={previews.banner_image}
                    />
                </div>
              </div>

            </div>
          </div>

          <div className="add-content-wrap">
            <h4>First Section</h4>
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>First Section Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="first_section_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>First Section Image Alt Text<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="first_section_image_alt" type="text" className="form-control" placeholder="Enter First Section Image Alt Text" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>First Section Url<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="first_section_url" type="text" className="form-control" placeholder="Enter First Section Url" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>First Section Button Text<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="first_section_button_name" type="text" className="form-control" placeholder="Enter First Section Button Text" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.first_section_description} onChange={(event, editor) => handleEditorChange("first_section_description", editor.getData())}/>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>First Section Image (636 × 860)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="first_section_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]} 
                    onImageChange={handleChange}
                    imagePreview={previews.first_section_image}
                    />
                </div>
              </div>

            </div>
          </div>

          <div className="add-content-wrap">
            <h4>Second Section</h4>
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Second Section Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="second_section_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Second Section Image Alt Text<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="second_section_image_alt" type="text" className="form-control" placeholder="Enter Second Section Image Alt Text" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.second_section_description} onChange={(event, editor) => handleEditorChange("second_section_description", editor.getData())}/>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Second Section Image (873 × 818)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="second_section_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]} 
                    onImageChange={handleChange}
                    imagePreview={previews.second_section_image}
                    />
                </div>
              </div>

            </div>
          </div>

          <div className="add-content-wrap">
            <h4>Third Section</h4>
            <div className="row">
              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Third Section Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="third_section_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Third Section Subtitle<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="third_section_subtitle" type="text" className="form-control" placeholder="Enter Subtitle" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Third Section Image Alt Text<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="third_section_image_alt" type="text" className="form-control" placeholder="Enter Third Section Image Alt Text" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Third Section Url<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="third_section_url" type="text" className="form-control" placeholder="Enter Third Section Url" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Third Section Button Text<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="third_section_button_name" type="text" className="form-control" placeholder="Enter Third Section Button Text" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.third_section_description} onChange={(event, editor) => handleEditorChange("third_section_description", editor.getData())}/>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Third Section Image (778 × 948)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="third_section_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]} 
                    onImageChange={handleChange}
                    imagePreview={previews.third_section_image}
                    />
                </div>
              </div>

            </div>
          </div>

          <div className="add-content-wrap">
            <h5>Faq Section</h5>
            <div className="row">

              {postData.faqs.map((faq, index) => (
                <div key={index} className="col-lg-6" style={{ position: "relative" }}>
                  <div className="add-page-inputs input-add-image">
                    <div className="label-wrap-add">
                      <label>Question<small>*</small></label>
                    </div>
                    <input required className="form-control" type="text" placeholder={`Question ${index + 1}`} value={faq.question} onChange={(e) => handleFaqChange(index, "question", e.target.value)} />
                  </div>

                  <div className="add-page-inputs input-add-image">
                    <div className="label-wrap-add">
                      <label>Answer<small>*</small></label>
                    </div>
                    <input required className="form-control" placeholder={`Answer ${index + 1}`}
                      value={faq.answer} onChange={(e) => handleFaqChange(index, "answer", e.target.value)} />
                  </div>
                  {index >= 2 && (
                    <button type="button" style={{ position: "absolute", background: "linear-gradient(270deg,#e20814,#a80008)", top: "5px", right: "10px", color: "#fff", border: "none", borderRadius: "8px", fontSize: "12px", padding: "3px 15px" }} onClick={() => removeFaq(index)}>
                      REMOVE
                    </button>
                  )}
                </div>
              ))}

              <div className="col-lg-12 text-center">
                <button type="button" className="add-faqs" onClick={addFaq} style={{ background: "green", top: "5px", right: "10px", color: "#fff", border: "none", borderRadius: "8px", fontSize: "14px", padding: "5px 15px", marginTop: "15px" }}>
                  Add New Faq
                </button>
              </div>
            </div>
          </div>

        </form>

        <button type="submit" form="blogAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
